var slideCounter = avm.require('avast.web.slideCounter');


var infFeaturesLg = tns({
	"container": ".slider-infFeatures",
	"controlsContainer": ".slider-infFeatures-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"768": {
			"items": 2
		},
		"992": {
			"items": 1,
			"gutter": 32
		},
		"1280": {
			"items": 2
		}
	}
});
slideCounter(infFeaturesLg);